export interface AppointmentData {
  firstName: string;
  lastName: string;
  department: string;
  time: string;
}

export type FormErrors = Partial<Record<'firstName' | 'lastName' | 'department' | 'time', string>>;

export const DEPARTMENTS: string[] = [
  'Breast Clinic',
  'Cardiology',
  'Chemotherapy',
  'Colorectal Surgery',
  'Dermatology',
  'Diabetic Medicine',
  'Dietetics',
  'Endocrinology',
  'ENT',
  'Fracture Clinic',
  'Gastroenterology',
  'General Surgery',
  'Gynaecology',
  'Haematology',
  'Hand Therapy',
  'Medicine for the Elderly',
  'Neurology',
  'Occupational Therapy',
  'Oncology',
  'Ophthalmology',
  'Paediatrics',
  'Pain Clinic',
  'Physiotherapy',
  'Pre-Assessment',
  'Respiratory Medicine',
  'Rheumatology',
  'Speech and Language Therapy',
  'Urology',
];

/** Unicode letters, spaces, hyphen, apostrophe, full stop — excludes digits and symbols like @/# */
export const PERSON_NAME_PATTERN = /^[\p{L}\s'\-.]+$/u;

export function isValidPersonName(value: string): boolean {
  const t = value.trim();
  if (!t) return false;
  if (/\d/.test(t)) return false;
  if (!PERSON_NAME_PATTERN.test(t)) return false;
  return /\p{L}/u.test(t);
}

export function validateForm(data: AppointmentData): FormErrors {
  const errors: FormErrors = {};
  if (!data.firstName.trim()) {
    errors.firstName = "Enter the patient's first name";
  } else if (!isValidPersonName(data.firstName)) {
    errors.firstName =
      "Use letters for the patient's first name. You can include spaces, hyphens or apostrophes (for example, Mary-Jane or O\u2019Brien). Numbers and symbols are not accepted.";
  }
  if (!data.lastName.trim()) {
    errors.lastName = "Enter the patient's last name";
  } else if (!isValidPersonName(data.lastName)) {
    errors.lastName =
      "Use letters for the patient's last name. You can include spaces, hyphens or apostrophes (for example, Smith-Jones). Numbers and symbols are not accepted.";
  }
  if (!data.department) {
    errors.department = 'Select a department';
  }
  if (!data.time) {
    errors.time = 'Enter the appointment time';
  }
  return errors;
}
